<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu
      pageTitle="create_adjustment"
      :items="breadcrumbItems"
      :showHome="false"
    />
    <ChooseForm
      :warehouses="warehouses"
      v-model:warehouseId="form.warehouse_id"
      v-model:referenceNo="form.ref"
      v-model:adjustmentDate="form.date"
      :warehouseLocked="warehouseLockedToProfile"
      :isLoading="isLoadingData"
      @search-product="handleProductSearch"
      :searchResults="searchResults"
      :showResults="showResults"
      @add-product="addProduct"
    />
    <SelectedProducts
      :products="selectedProducts"
      @remove="removeProduct"
      @update-quantity="updateProductQuantity"
      @update-type="updateProductType"
    />
    <NotesContent v-model="form.note" @submit="handleSubmit" :isSubmitting="isSubmitting" />

    <div class="flex-grow-1"></div>
    <MainFooter />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import ChooseForm from "../../components/Adjustments/CreateAdjustments/ChooseForm.vue";
import SelectedProducts from "../../components/Adjustments/CreateAdjustments/SelectedProducts.vue";
import NotesContent from "../../components/Adjustments/CreateAdjustments/NotesContent.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import { useAdjustmentForm } from "../../composables/useAdjustment";

export default defineComponent({
  name: "CreateAdjustmentsPage",
  components: {
    MainHeader,
    MainSidebar,
    BreadcrumbMenu,
    ChooseForm,
    SelectedProducts,
    NotesContent,
    MainFooter,
  },
  setup() {
    return useAdjustmentForm();
  },
});
</script>
